import React from 'react';
import { Icon } from './Icon.js';
export const IconCurve2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 21C16.32 21 7.68 3 21 3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", fill: "none" })));
};
//# sourceMappingURL=IconCurve2.js.map